export default {
  mapRightClick: {
    options: 'Možnosti',
    addDestinationToRoute: 'Přidat jako cíl',
    directionsFromHere: 'Instrukce odtud',
    directionsToHere: 'Instrukce sem',
    nonStopDirectionsToHere: 'Přímo sem',
    addRouteStop: 'Sem přidat zastávku',
    centerHere: 'Vystředit zde',
    addAsIsochroneCenter: 'Přidat jako střed dosahu',
    inspectDataOnOSM: 'Prohlédnout data na OSM'
  }
}
